
import $ from "jquery"

import "bootstrap3-tooltip"
import "bootstrap3-popover"

import I18n from "plugins/i18n-js"
import * as Routes from "plugins/js-routes"
import Authentication_manager from "app/authentication/manager"

interface InputSelector {
  scope?:                       string | JQuery
  reject_promotions_container?: string
  tooltip?:                     string
}
const DEFAULT_SELECTOR = {
  scope:                        ".cell-serviced-apartment-contact-request-box",
  reject_promotions_container:  ".cell-serviced-apartment-contact-request-box__reject_promotions-container",
  tooltip:                      ".cell--listing-contact-request-box--tooltip",
}

interface InputOptions {
  popover_options?: Bootstrap3Popover.Options,
}

const DEFAULT_POPOVER_OPTIONS = {
  placement:  "auto",
}

const init = (selector?: InputSelector, options?: InputOptions) => {
  const sele = Object.assign({}, DEFAULT_SELECTOR, selector)
  const $scope = $(sele.scope)
  const $tooltip = $scope.find(sele.tooltip)
  const $reject_promotions_container = $scope.find(sele.reject_promotions_container)

  const popover_options = Object.assign(
    {},
    DEFAULT_POPOVER_OPTIONS,
    options == null ? {} : options.popover_options,
    {
      container:  sele.scope,
      content:    I18n.t("concepts.serviced_apartment_buildings.contact.request.box.sentences.tooltip_html",
                    {
                      privacy_link: Routes.privacy_policy_page_path({locale: I18n.locale}),
                    },
                  ),
      html:       "true",
    },
  )
  $tooltip.popover(popover_options)

  Authentication_manager.on("sign_up:success:action", () => {
    $reject_promotions_container.html("")
  })

  Authentication_manager.on("sign_in:success:action", () => {
    $reject_promotions_container.html("")
  })
}

export default {init}
